import * as React from 'react';
import * as aboutWorkshop from "./style.module.scss";
export const AboutWorkshop = () => {
  return (
    <section className={aboutWorkshop.aboutWorkshop}>
      <div className={'container'}>
        <div className={aboutWorkshop.aboutWorkshop__wrap}>
          <div className={aboutWorkshop.aboutWorkshop__info}>
            <h4 className={aboutWorkshop.aboutWorkshop__title}>На&nbsp;онлайн-тренинге вы:</h4>
            <ul>
              <li className={aboutWorkshop.aboutWorkshop__item}>
                освоите методику изучения любого языка до&nbsp;базового уровня за&nbsp;30&nbsp;дней;
              </li>
              <li className={aboutWorkshop.aboutWorkshop__item}>
                c&nbsp;нуля до&nbsp;разговора на&nbsp;бытовые темы: погода и&nbsp;времена года, страны
                и&nbsp;путешествия, хобби и&nbsp;свободное время, одежда, еда и&nbsp;не&nbsp;только;
              </li>
              <li className={aboutWorkshop.aboutWorkshop__item}>
                выучите более 2&nbsp;000 новых иностранных слов или иероглифов в&nbsp;1&nbsp;из&nbsp;9&nbsp;языков:
                английский, испанский, итальянский, немецкий, французский, китайский, корейский, японский или хинди;
              </li>
              <li className={aboutWorkshop.aboutWorkshop__item}>научитесь понимать иностранную речь на&nbsp;слух;</li>
              <li className={aboutWorkshop.aboutWorkshop__item}>
                сможете общаться с&nbsp;иностранцами без русского акцента;
              </li>
              <li className={aboutWorkshop.aboutWorkshop__item}>
                сможете пройти интервью и&nbsp;составлять письма, сообщения, инструкции на&nbsp;иностранном языке.
              </li>
            </ul>
          </div>

          <div className={aboutWorkshop.aboutWorkshop__img}></div>
        </div>
      </div>
    </section>
  );
};
